angular.module("documents_types")

    .controller('DocumentsTypesListCtrl', ['$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', 'uiGridConstants', '$filter', 'LoginService', '$stateParams', '$state',
        function ($rootScope, $scope, Restangular, gridService, modalService, uiGridConstants, $filter, LoginService, $stateParams, $state) {

            $rootScope.title = $filter('translate')('documents_types.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('documents_types.subtitleList') }
            ];

            $scope.gridOptionsDocumentsTypes = {
                pdfTitle: $filter('translate')('documents_types.pdf_title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                paginationPageSizes: [20, 50, 100],
                paginationPageSize: 100,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'name', displayName: $filter('translate')('documents_types.name'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                    { name: 'code', displayName: $filter('translate')('documents_types.code'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                    { name: 'icon', displayName: $filter('translate')('documents_types.icon'), enableFiltering: true, enableHiding: false, enableColumnMenu: false, cellTemplate: "<div class=\"{{row.entity.icon}}\" style=\"text-align: center;\">&nbsp;</div>" },
                    { name: 'order', displayName: $filter('translate')('documents_types.order'), enableFiltering: true, enableHiding: false, enableColumnMenu: false },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('general.edit'), action: 'ui-sref="documents_types.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('general.delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },

                ],
                getData: function (options) {

                    return Restangular.all('DocumentsTypes').getList(options);
                }

            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("documents_types.edit", { id: rowEntity.id });
            }

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('providers.button_delete'),
                    message: $filter('translate')('providers.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('DocumentsTypes', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('providers.delete_success'));
                            $scope.gridOptionsDocumentsTypes.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });

            };


   }]);